import * as Yup from "yup";

export const schema = Yup.object().shape({
  email: Yup.string()
    .required("Ingresa tu correo electrónico")
    .trim("El correo electrónico no puede contener espacio")
    .email("Ingresa un correo electrónico válido"),
  password: Yup.string().required("Ingresa tu contraseña"),
});

interface FormValues {
  email: string;
  password: string;
}

export const initialValues: FormValues = {
  email: "",
  password: "",
};
